import React, { useEffect } from "react";

export type Theme = "light" | "dark" | "high-contrast";

export const useTheme = () => {
  const [theme, setTheme] = React.useState<Theme>("light");

  const retrieveTheme = React.useCallback(() => {
    if (
      window.matchMedia &&
      window.matchMedia("(prefers-color-scheme: dark)").matches
    ) {
      setTheme("dark");
    } else if (
      window.matchMedia &&
      window.matchMedia("(forced-colors: active)").matches
    ) {
      setTheme("high-contrast");
    } else {
      setTheme("light");
    }
  }, []);
  useEffect(() => {
    window
      .matchMedia("(prefers-color-scheme: dark)")
      .addEventListener("change", (_) => {
        retrieveTheme();
      });
    window
      .matchMedia("(forced-colors: active)")
      .addEventListener("change", (_) => {
        retrieveTheme();
      });

    retrieveTheme();

    return () => {
      window
        .matchMedia("(prefers-color-scheme: dark)")
        .removeEventListener("change", (_) => {
          retrieveTheme();
        });
      window
        .matchMedia("(forced-colors: active)")
        .removeEventListener("change", (_) => {
          retrieveTheme();
        });
    };
  });

  return {
    theme,
  };
};
